import { ReactComponent as LogoutIcon } from 'core/assets/images/icones/logoutIcon.svg'
import { UserContext } from 'core/contexts/UserContext'
import { UseKeycloakService } from 'core/packages/KeycloakProvider'
import { t } from 'i18next'
import { useContext } from 'react'

export const Logout = () => {
  const kc = UseKeycloakService()
  const { clearUserSession } = useContext(UserContext)

  const handleLogout = () => {
    clearUserSession()
    kc.getKc().logout({ redirectUri: window.location.origin })
  }

  return (
    <LogoutIcon
      className="logout-option ml-[15px]"
      onClick={handleLogout}
      aria-label={t('layout.logout')}
    />
  )
}
